/**
 * Imports - External
 * --------------------------------------------------------------------------
 */

import { green } from "@mui/material/colors";

export const themes = {
    allPendingColor: '#777',
    allPendingBackground: '0',
    allPendingBorder: '0',
    allPendingTotal: '#d1d1d1', //#a3a3a3
    allPendingTotalBorder: '2px solid #a8a8a8',

    somePendingColor: '#466591',
    somePendingBackground: '#547eb855',
    somePendingBorder: '2px solid #46659155',
    somePendingTotal: '#b1d1fc',
    somePendingTotalBorder: '2px solid #82a2cf',

    nonePendingColor: `${green[900]}`,
    nonePendingBackground: `${green[200]}88`,
    nonePendingBorder: `2px solid ${green[300]}`,
    nonePendingTotalBorder: `2px solid ${green[300]}`
}